// extracted by mini-css-extract-plugin
module.exports = {"root":"ColorSelect_root__106t2","checkbox":"ColorSelect_checkbox__1FmvJ","group":"ColorSelect_group__2Zw49","title":"ColorSelect_title__281u8"};